import {BaseModel} from '.'
import {ignoreForInvoicing} from '@/lib/constants'
import Moment from 'moment'

/**
 * Competition model
 */
class CompetitionRegistration extends BaseModel {
  defaults () {
    return {
      id: null,
      competitionId: '',
      schoolId: '',
      type: '-',
      registrationCount: 0,
      prices: 0,
      invoiceRequired: false,
      registrationsInvoiced: 0,
      payload: null,
      payment: {
        total: 0,
        payed: 0,
        open: 0
      },
      createdAt: null,
      updatedAt: null,
      deletedAt: null
    }
  }

  loaded () {
    return !!this.schoolId
  }

  registered () {
    return this.id !== null
  }

  deleted () {
    return !!this.deletedAt
  }

  allowInvoiceCreation () {
    return ignoreForInvoicing.indexOf(this.competitionId) === -1
  }

  mutations () {
    return {
      createdAt: createdAt => (createdAt && new Moment(createdAt)) || false,
      deletedAt: deletedAt => (deletedAt && new Moment(deletedAt)) || false
    }
  }

  // Route configuration
  routes () {
    return {
      fetch: '/registrations/{id}',
      save: '/registrations'
    }
  }
}

export {CompetitionRegistration}



//////////////////
// WEBPACK FOOTER
// ./src/models/CompetitionRegistration.js
// module id = 885
// module chunks = 1